import React, { useEffect } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { ArrowLeft, Ticket, FileText } from "lucide-react";
import { LEGAL_DOCS, LEGAL_LINKS } from "./legalDocs";

export default function LegalPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const doc = LEGAL_DOCS[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!doc) return <Navigate to="/legal/termini" replace />;

  return (
    <div className="min-h-screen bg-slate-50" data-testid={`legal-page-${slug}`}>
      <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-slate-100">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-3">
          <button
            onClick={() => { if (window.history.length > 1) navigate(-1); else navigate("/"); }}
            data-testid="legal-back"
            aria-label="Indietro"
            className="h-10 w-10 -ml-1 rounded-full hover:bg-slate-100 flex items-center justify-center shrink-0 transition-colors"
          >
            <ArrowLeft className="h-5 w-5 text-slate-700" />
          </button>
          <button onClick={() => navigate("/")} className="flex items-center gap-2 shrink-0" data-testid="legal-brand-home">
            <div className="h-9 w-9 rounded-xl kn-gradient flex items-center justify-center"><Ticket className="h-5 w-5 text-white" /></div>
            <span className="font-extrabold text-lg tracking-tight text-slate-900">Koupo<span className="text-[#E63946]">Now</span></span>
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6 pb-16">
        <div className="kn-card p-5 sm:p-7">
          <div className="flex items-center gap-2 text-[#E63946] font-bold text-xs uppercase tracking-wide mb-2">
            <FileText className="h-4 w-4" /> Documenti legali
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 leading-tight">{doc.title}</h1>
          {doc.subtitle && <p className="text-sm text-slate-500 italic mt-1">{doc.subtitle}</p>}
          <p className="text-xs text-slate-400 font-semibold mt-2">Ultimo aggiornamento: {doc.updated}</p>

          <div className="mt-5 border-t border-slate-100 pt-5">{doc.body}</div>
        </div>

        {/* Cross-links to the other documents */}
        <div className="mt-5 flex flex-wrap gap-2" data-testid="legal-crosslinks">
          {LEGAL_LINKS.filter((l) => l.slug !== slug).map((l) => (
            <button
              key={l.slug}
              data-testid={`legal-link-${l.slug}`}
              onClick={() => navigate(`/legal/${l.slug}`)}
              className="h-10 px-4 rounded-xl bg-white border border-slate-200 text-sm font-bold text-slate-700 hover:border-[#E63946] hover:text-[#E63946] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <p className="text-center text-xs text-slate-400 mt-8">
          EAT ME S.r.l. · P.IVA 02548710413 · Via Palmiro Togliatti 21/2, 61122 Pesaro (PU)
        </p>
      </main>
    </div>
  );
}
